import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const colors = ['#FFD700', '#FF4500', '#1E90FF', '#32CD32', '#FF69B4', '#9370DB'];
interface ConfettiPieceProps {
  x: number;
  delay: number;
  color: string;
}
const ConfettiPiece = ({
  x,
  delay,
  color
}: ConfettiPieceProps) => {
  return <motion.div initial={{
    y: -20,
    x,
    rotate: 0,
    opacity: 1
  }} animate={{
    y: '110vh',
    x: x + (Math.random() * 200 - 100),
    rotate: 720,
    opacity: 0
  }} transition={{
    duration: 3 + Math.random() * 2,
    delay: delay,
    ease: 'linear'
  }} style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '10px',
    height: '10px',
    backgroundColor: color,
    borderRadius: Math.random() > 0.5 ? '50%' : '2px',
    zIndex: 9999,
    pointerEvents: 'none'
  }} data-id="element-110" />;
};
export function Confetti() {
  const [pieces, setPieces] = useState<ConfettiPieceProps[]>([]);
  useEffect(() => {
    const newPieces: ConfettiPieceProps[] = [];
    const count = 100; // Number of confetti pieces
    for (let i = 0; i < count; i++) {
      newPieces.push({
        x: Math.random() * window.innerWidth,
        delay: Math.random() * 2,
        color: colors[Math.floor(Math.random() * colors.length)]
      });
    }
    setPieces(newPieces);
  }, []);
  return <>
      {pieces.map((p, i) => <ConfettiPiece key={i} {...p} data-id="element-111" />)}
    </>;
}